import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import LearningCorrectAnswersRateTable from './LearningCorrectAnswersRateTable';
import { CorrectAnswersRateListService } from '../services/LearningListService';

class LearningCorrectAnswersRateTableContainer extends React.Component {
  constructor(props) {
    super(props);
    CorrectAnswersRateListService.load();
  }

  render() {
    return (
      <LearningCorrectAnswersRateTable
        loading={CorrectAnswersRateListService.fetch.fetching}
        values={toJS(CorrectAnswersRateListService.byCourse)}
        feedbackColorRender={CorrectAnswersRateListService.getFeedbackColor}
        formatter={CorrectAnswersRateListService.getFormattedValue}
      />
    );
  }
}

export default observer(LearningCorrectAnswersRateTableContainer);
